export const transformSavedVideos = (savedVideos) =>
  savedVideos.map((item) => ({
    id: {
      videoId: item.video_id,
    },
    snippet: {
      title: item.title || '',
      channelTitle: item.channel_title || '',
      channelId: item.channel_id || '',
      publishTime: item.saved_at || '',
      thumbnails: {
        high: {
          url: item.thumbnail_url || '',
        },
      },
    },
  }));
